/* import __COLOCATED_TEMPLATE__ from './flex-test.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();